import type { ConsentSnapshot } from '../types'

const COOKIEYES_DEFAULT_CONSENT: ConsentSnapshot = {
  functional: false,
  statistics: false,
  marketing: false,
}

const OPEN_DEFAULT_CONSENT: ConsentSnapshot = {
  functional: true,
  statistics: true,
  marketing: true,
}

function normalizeHost(host: string | null | undefined): string {
  return (host || '').trim().toLowerCase()
}

function stripPort(host: string): string {
  return host.replace(/:\d+$/, '')
}

function isLocalUkHost(host: string): boolean {
  return (
    (host.startsWith('localhost') || host.startsWith('127.0.0.1')) &&
    host.includes(':3001')
  )
}

export function hostUsesCookieYesConsent(
  host: string | null | undefined
): boolean {
  const normalized = normalizeHost(host)
  if (!normalized) return true
  if (isLocalUkHost(normalized)) return true

  const hostname = stripPort(normalized)
  return (
    hostname === 'vanishingincmagic.co.uk' ||
    hostname.endsWith('.vanishingincmagic.co.uk')
  )
}

export function getDefaultConsentForHost(
  host: string | null | undefined
): ConsentSnapshot {
  return hostUsesCookieYesConsent(host)
    ? COOKIEYES_DEFAULT_CONSENT
    : OPEN_DEFAULT_CONSENT
}
